import { getApiErrorMessage, normalizeIndianMobile } from '@/utils/data'
import type { LoginResponse } from '@/services/authService'

export const getAuthErrorStatus = (error: unknown): number | undefined => {
  const value = error as { status?: number; response?: { status?: number } }
  return value?.status ?? value?.response?.status
}

export const getLoginErrorMessage = (error: unknown): string => {
  if (getAuthErrorStatus(error) === 401) return 'Wrong mobile number or password.'
  return getApiErrorMessage(error, 'Unable to sign in')
}

export const normalizeMobile = normalizeIndianMobile

export const assertPortalRolesPresent = (data: LoginResponse) => {
  const roles = data.userRoles ?? []
  if (!roles.length) {
    throw new Error('Login response did not include portal roles')
  }
}
